import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      width={500}
      height={372.61}
      viewBox="0 0 500 372.61"
      {...props}
    >
      <g data-name="Background Complete">
        <path
          data-name="Rectangle 1804"
          fill="#ebebeb"
          d="M0 327.45h500v.25H0z"
        />
        <path
          data-name="Rectangle 1805"
          fill="#ebebeb"
          d="M416.78 343.54h33.12v.25h-33.12z"
        />
        <path
          data-name="Rectangle 1806"
          fill="#ebebeb"
          d="M292.75 343.67h8.69v.25h-8.69z"
        />
        <path
          data-name="Rectangle 1807"
          fill="#ebebeb"
          d="M354.33 334.26h61.44v.25h-61.44z"
        />
        <path
          data-name="Rectangle 1808"
          fill="#ebebeb"
          d="M212.45 340.16h12.69v.25h-12.69z"
        />
        <path
          data-name="Rectangle 1809"
          fill="#ebebeb"
          d="M166.72 340.16h36.83v.25h-36.83z"
        />
        <path
          data-name="Rectangle 1810"
          fill="#ebebeb"
          d="M52.46 335.94h25.43v.25H52.46z"
        />
        <path
          data-name="Rectangle 1811"
          fill="#ebebeb"
          d="M83.89 335.94h74.89v.25H83.89z"
        />
        <path
          data-name="Path 11564"
          d="M237 282.85H43.91a5.71 5.71 0 01-5.7-5.71V5.71A5.71 5.71 0 0143.91 0H237a5.71 5.71 0 015.71 5.71v271.43a5.71 5.71 0 01-5.71 5.71zM43.91.25a5.46 5.46 0 00-5.45 5.46v271.43a5.46 5.46 0 005.45 5.46H237a5.47 5.47 0 005.46-5.46V5.71A5.47 5.47 0 00237 .25z"
          fill="#ebebeb"
        />
        <path
          data-name="Path 11565"
          d="M453.31 282.85h-193.1a5.72 5.72 0 01-5.71-5.71V5.71A5.72 5.72 0 01260.21 0h193.1A5.71 5.71 0 01459 5.71v271.43a5.71 5.71 0 01-5.69 5.71zM260.21.25a5.47 5.47 0 00-5.46 5.46v271.43a5.47 5.47 0 005.46 5.46h193.1a5.47 5.47 0 005.46-5.46V5.71a5.47 5.47 0 00-5.46-5.46z"
          fill="#ebebeb"
        />
        <path
          data-name="Rectangle 1812"
          fill="#e6e6e6"
          d="M433.82 194.55H190.78V17.02h243.04z"
        />
        <path
          data-name="Rectangle 1813"
          fill="#f0f0f0"
          d="M431.33 194.55H180.04V17.02h251.29z"
        />
        <path
          data-name="Rectangle 1814"
          fill="#fafafa"
          d="M416.29 32.07v147.45H195.08V32.07z"
        />
        <path
          data-name="Path 11566"
          d="M362.51 179.51L312.15 32.06h-48.09l50.36 147.45z"
          fill="#fff"
        />
        <path
          data-name="Path 11567"
          d="M304.09 179.51L253.73 32.06h-18.74l50.36 147.45z"
          fill="#fff"
        />
        <path
          data-name="Rectangle 1815"
          fill="#e6e6e6"
          d="M196.99 32.06v147.45h-1.91V32.06z"
        />
        <path
          data-name="Rectangle 1816"
          fill="#e0e0e0"
          d="M150.39 146.26H64.57V24.59h85.82z"
        />
        <path
          data-name="Rectangle 1817"
          fill="#f5f5f5"
          d="M146.96 146.26H58.5V24.59h88.46z"
        />
        <path
          data-name="Rectangle 1818"
          fill="#fff"
          d="M138.23 34.18v102.49h-71V34.18z"
        />
        <path
          data-name="Path 11568"
          d="M97.93 231.44c6.37-15.71 21.52-21.57 26.76-31.49 6.85-13 6.81-32.51 1-39.55-5.08-6.11-21.88 35.24-23.77 39.87a132.14 132.14 0 00-9.62 39.11c.14-9.71.27-18.63.38-25.51.36-22.45.8-29.66 1-31.89.7-1.08 1.53-2.34 2-3 4.07-5.74 13.09-12.56 17.6-20.89 6.58-12.17 5.52-26.73.9-32.15-4.83-5.67-13.36 7.73-17.89 21s-2.6 26-3.87 37c-.26 2.17-.54 10.38-.79 21.78-1.38-12.26-4.12-20.48-9.19-28.13-6.24-9.41-11.63-20.88-16.77-19.4s-2.38 16.65 1.69 27.3C71 195 88.85 204.42 91.48 212.05c-.31 15.44-.59 35-.78 53.23-1.41-9.41-.44-10.2-6.22-24.61-3.43-8.57-17.48-19.13-19.18-13.24s.87 17 6.18 24.79c4.29 6.29 13.8 6.28 16 10.18.51.91 2.21 4.4 3.18 6.4-.23 22.24-.33 41.87-.22 48.57l.92.07c0-1.73.07-13.05.25-28 2.31-8 17.86-12.62 22.66-20.9 5-8.67 8.64-18.79 6.48-25.56-1.8-5.65-16 2-21.71 11.39-3.83 6.23-6.17 12.89-7.26 21.83.13-10.2.28-21.16.42-31.5 1.17-2.6 3.8-8.55 5.73-13.26z"
          fill="#b8d98a"
        />
        <path
          data-name="Path 11569"
          d="M107.06 327.45H74.38a3.75 3.75 0 01-3.67-3L68.39 313h44.67l-2.32 11.44a3.77 3.77 0 01-3.68 3.01z"
          fill="#472a04"
        />
        <path
          data-name="Path 11570"
          d="M114 317.44H67.45a2.2 2.2 0 01-2.18-1.95l-1-8.45a2.2 2.2 0 012.18-2.44h48.44a2.19 2.19 0 012.18 2.44l-1 8.45a2.2 2.2 0 01-2.07 1.95z"
          fill="#472a04"
        />
        <path
          data-name="Rectangle 1819"
          fill="#f0f0f0"
          d="M415.62 320.16h-9.99V212.67h9.99z"
        />
        <path
          data-name="Rectangle 1820"
          fill="#f0f0f0"
          d="M411.79 327.32H202.06v-7.16h209.73z"
        />
        <path
          data-name="Rectangle 1821"
          fill="#f5f5f5"
          d="M198.23 212.66h207.41v107.49H198.23z"
        />
        <path
          data-name="Rectangle 1822"
          fill="#e0e0e0"
          d="M418.31 212.66h-10.32v-6.78h10.32z"
        />
        <path
          data-name="Rectangle 1823"
          fill="#ebebeb"
          d="M195.54 205.89h212.45v6.78H195.54z"
        />
        <path
          data-name="Path 11571"
          d="M390.75 259.09H213.11a8 8 0 01-8-8V228a8 8 0 018-8h177.64a8 8 0 018 8v23a8 8 0 01-8 8.09zM213.11 222a6 6 0 00-6 6v23a6 6 0 006 6h177.64a6 6 0 006-6v-23a6 6 0 00-6-6z"
          fill="#fff"
        />
        <path
          data-name="Path 11572"
          d="M390.75 307.24H213.11a8 8 0 01-8-8v-23a8 8 0 018-8h177.64a8 8 0 018 8v23a8 8 0 01-8 8zm-177.64-37.08a6 6 0 00-6 6v23a6 6 0 006 6h177.64a6 6 0 006-6v-23a6 6 0 00-6-6z"
          fill="#fff"
        />
        <path
          data-name="Path 11573"
          d="M350.38 243.09h-96.9a2.61 2.61 0 01-2.6-2.6v-1.89a2.61 2.61 0 012.6-2.6h96.9a2.61 2.61 0 012.6 2.6v1.89a2.61 2.61 0 01-2.6 2.6zm-96.9-5.09a.62.62 0 00-.6.6v1.89a.61.61 0 00.6.6h96.9a.6.6 0 00.6-.6v-1.89a.61.61 0 00-.6-.6z"
          fill="#fff"
        />
        <path
          data-name="Path 11574"
          d="M350.38 291.24h-96.9a2.61 2.61 0 01-2.6-2.6v-1.89a2.61 2.61 0 012.6-2.6h96.9a2.61 2.61 0 012.6 2.6v1.89a2.61 2.61 0 01-2.6 2.6zm-96.9-5.09a.62.62 0 00-.6.6v1.89a.61.61 0 00.6.6h96.9a.6.6 0 00.6-.6v-1.89a.61.61 0 00-.6-.6z"
          fill="#fff"
        />
      </g>
      <ellipse
        data-name="&lt;Path&gt;"
        cx={193.89}
        cy={11.32}
        rx={193.89}
        ry={11.32}
        transform="translate(51.11 349.97)"
        fill="#f5f5f5"
      />
      <path
        data-name="Rectangle 1824"
        fill="#407bff"
        d="M374.414 118.682l.38-5.888.999.065-.381 5.888z"
      />
      <path
        data-name="Rectangle 1825"
        fill="#407bff"
        d="M375.055 108.242l1.248-19.35.998.065-1.248 19.35z"
      />
      <path
        data-name="Path 11575"
        d="M364.44 60.78H246.89A12.15 12.15 0 00235 72l-15.19 234.5a10.39 10.39 0 0010.47 11.19h117.53a12.15 12.15 0 0011.92-11.19L374.91 72a10.39 10.39 0 00-10.47-11.22z"
        fill="#407bff"
      />
      <path
        data-name="Path 11576"
        d="M360.71 60.78H246.89A12.15 12.15 0 00235 72l-15.19 234.5a10.39 10.39 0 0010.47 11.19h113.8A12.15 12.15 0 00356 306.48L371.18 72a10.39 10.39 0 00-10.47-11.22z"
        fill="#fff"
        opacity={0.7}
      />
      <path
        data-name="Path 11577"
        d="M351.11 300.35h-125.2a3.42 3.42 0 01-3.42-3.65l13.74-212.19a3.42 3.42 0 013.41-3.2h125.21a3.43 3.43 0 013.42 3.69l-13.74 212.2a3.42 3.42 0 01-3.42 3.15z"
        fill="#fff"
      />
      <path
        data-name="Path 11578"
        d="M323.29 74.36h-45.51a1.68 1.68 0 01-1.7-1.81 2 2 0 011.92-1.81h45.51a1.68 1.68 0 011.7 1.81 2 2 0 01-1.92 1.81z"
        fill="#fff"
      />
      <path
        data-name="Path 11579"
        d="M287.77 309.26a4.76 4.76 0 01-4.69 4.46 4.2 4.2 0 01-4.23-4.46 4.76 4.76 0 014.69-4.46 4.2 4.2 0 014.23 4.46z"
        fill="#fff"
      />
      <path
        data-name="Path 11580"
        d="M337.47 140.08H230.56L223.76 245h113.71a11.23 11.23 0 0011.2-11.19v-82.53a11.23 11.23 0 00-11.2-11.2z"
        fill="#407bff"
        opacity={0.2}
      />
      <rect
        data-name="Rectangle 1826"
        width={153.42}
        height={104.91}
        rx={11.2}
        transform="translate(185.29 130.75)"
        fill="#cf1e22"
      />
      <path
        data-name="Path 11581"
        d="M181.71 129.55a1 1 0 01-.7-.29l-1.8-1.8a1 1 0 111.42-1.41l1.79 1.79a1 1 0 01-.71 1.71z"
        fill="#407bff"
      />
      <path
        data-name="Path 11582"
        d="M179 135.83h-2.53a1 1 0 010-2H179a1 1 0 010 2z"
        fill="#407bff"
      />
      <path
        data-name="Path 11583"
        d="M188.08 126.85a1 1 0 01-1-.93l-.18-2.53a1 1 0 111.99-.14l.19 2.52a1 1 0 01-.93 1.07z"
        fill="#407bff"
      />
      <path
        data-name="Path 11584"
        d="M273.19 224.88l40.23 40.22v-40.22z"
        fill="#cf1e22"
      />
      <path
        data-name="Path 11585"
        d="M284.22 207.26l-2-8.5a15.319 15.319 0 010-6.77l2.71-12.1a23.7 23.7 0 00-12.54-26.3c.08-.23.17-.44.23-.68a5.724 5.724 0 10-11.17-2.51 4.431 4.431 0 00-.09.72 23.72 23.72 0 00-22.57 18.44l-2.71 12.09a15.38 15.38 0 01-2.9 6.12l-5.39 6.85a5.05 5.05 0 002.87 8l47.5 10.64a5 5 0 006.06-6z"
        fill="#fff"
      />
      <path
        data-name="Path 11586"
        d="M248.35 209.88a2.25 2.25 0 00-2.7 2.59 8.21 8.21 0 0014.83 3.32 2.25 2.25 0 00-1.33-3.49z"
        fill="#fff"
      />
      <path
        data-name="Path 11587"
        d="M211.87 193a1.5 1.5 0 01-1.25-.67 32.08 32.08 0 018.87-44.49 1.5 1.5 0 011.66 2.5 29.09 29.09 0 00-8 40.33 1.5 1.5 0 01-.41 2.08 1.52 1.52 0 01-.87.25z"
        fill="#fff"
      />
      <path
        data-name="Path 11588"
        d="M218.22 188.78a1.49 1.49 0 01-1.24-.66 24.44 24.44 0 016.75-33.89 1.5 1.5 0 011.67 2.49 21.44 21.44 0 00-5.93 29.73 1.5 1.5 0 01-.41 2.08 1.52 1.52 0 01-.84.25z"
        fill="#fff"
      />
      <path
        data-name="Path 11589"
        d="M224.58 184.54a1.46 1.46 0 01-1.24-.67 16.77 16.77 0 014.66-23.28 1.5 1.5 0 011.67 2.49 13.78 13.78 0 00-3.81 19.13 1.494 1.494 0 01-1.28 2.33z"
        fill="#fff"
      />
      <path
        data-name="Path 11590"
        d="M298.35 214.14a1.486 1.486 0 01-.69-2.81 29.09 29.09 0 0012.5-39.18 1.5 1.5 0 012.66-1.38A32.08 32.08 0 01299 214a1.47 1.47 0 01-.65.14z"
        fill="#fff"
      />
      <path
        data-name="Path 11591"
        d="M294.84 207.35a1.5 1.5 0 01-.69-2.83 21.43 21.43 0 009.21-28.88 1.5 1.5 0 012.67-1.38 24.42 24.42 0 01-10.5 32.92 1.56 1.56 0 01-.69.17z"
        fill="#fff"
      />
      <path
        data-name="Path 11592"
        d="M291.33 200.56a1.51 1.51 0 01-.69-2.84 13.77 13.77 0 005.93-18.58 1.5 1.5 0 012.67-1.37 16.81 16.81 0 01-7.24 22.62 1.53 1.53 0 01-.67.17z"
        fill="#fff"
      />
      <g>
        <path
          data-name="Path 11593"
          d="M203.36 70.89h-7.64a.85.85 0 00-.81.73l-1.6 15.24a.65.65 0 00.65.73h7.64a.84.84 0 00.81-.73L204 71.62a.65.65 0 00-.64-.73z"
          fill="#407bff"
        />
        <path
          data-name="Path 11594"
          d="M202.67 70.89h-6.95a.85.85 0 00-.81.73l-1.6 15.24a.65.65 0 00.65.73h7a.83.83 0 00.8-.73l1.6-15.24a.64.64 0 00-.69-.73z"
          fill="#fff"
          opacity={0.4}
        />
        <path
          data-name="Path 11595"
          d="M165.07 352.69c1 0 2-.14 2.35-.61a.72.72 0 000-.83 1 1 0 00-.63-.45c-1.36-.37-4.12 1.24-4.24 1.31a.19.19 0 00-.08.2.2.2 0 00.16.16 14.734 14.734 0 002.44.22zm1.22-1.57a1.44 1.44 0 01.37.05.62.62 0 01.39.27c.14.23.1.35 0 .42-.35.52-2.4.54-3.91.32a8.38 8.38 0 013.15-1.06z"
          fill="#407bff"
        />
        <path
          data-name="Path 11596"
          d="M162.61 352.47a.11.11 0 00.08 0c1-.43 2.82-2.19 2.63-3.1 0-.22-.21-.48-.74-.54a1.36 1.36 0 00-1.05.33c-1 .85-1.11 3-1.12 3.12a.21.21 0 00.09.18.2.2 0 00.11.01zm1.84-3.28h.11c.35 0 .38.18.38.22.12.55-1.14 1.93-2.11 2.52a4.33 4.33 0 011-2.49 1 1 0 01.62-.25z"
          fill="#407bff"
        />
        <path
          data-name="Rectangle 1827"
          fill="#ff8b7b"
          d="M153.69 333.53h8.1v18.75h-8.1z"
        />
        <path
          data-name="Path 11597"
          d="M94.95 343.34l8.09.88 5.27-18.21-8.09-.87z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11598"
          d="M106.8 346.06a3.211 3.211 0 002.45 0 .71.71 0 00.16-.82 1 1 0 00-.5-.58c-1.25-.69-4.35.17-4.48.21a.19.19 0 00-.14.17.22.22 0 00.12.19 15.909 15.909 0 002.39.83zm1.58-1.2a1.209 1.209 0 01.35.13.63.63 0 01.32.35.642.642 0 010 .42c-.48.42-2.49-.08-3.92-.65a8.421 8.421 0 013.25-.25z"
          fill="#407bff"
        />
        <path
          data-name="Path 11599"
          d="M104.45 345.24h.08c1-.18 3.3-1.4 3.34-2.32 0-.22-.08-.52-.59-.7a1.34 1.34 0 00-1.11.06c-1.18.56-1.84 2.62-1.87 2.71a.2.2 0 000 .19.17.17 0 00.15.06zm2.6-2.69h.12c.33.12.32.26.32.3 0 .56-1.6 1.57-2.7 1.9a4.28 4.28 0 011.56-2.16 1 1 0 01.7-.04z"
          fill="#407bff"
        />
        <path
          data-name="Path 11600"
          d="M103.47 343.47l-8.85-2.54a.68.68 0 00-.8.34l-3.26 6.46a1.24 1.24 0 00.81 1.72c3.1.83 4.65 1.08 8.54 2.2 2.39.69 7.26 2.35 10.57 3.3s4.53-2.16 3.25-2.84c-5.74-3.05-7.58-5.51-9.1-7.8a2.05 2.05 0 00-1.16-.84z"
          fill="#263238"
        />
        <path
          data-name="Path 11601"
          d="M161.7 351.34h-8.84a.66.66 0 00-.66.55l-1.29 7.2a1.24 1.24 0 001.23 1.44c3.19 0 7.79-.24 11.8-.24 4.69 0 7.25.26 12.75.26 3.32 0 4.1-3.36 2.69-3.67-6.39-1.38-10.08-1.53-15.7-4.91a4 4 0 00-1.98-.63z"
          fill="#263238"
        />
        <path
          data-name="Rectangle 1828"
          opacity={0.2}
          d="M153.69 333.53h8.1v9.67h-8.1z"
        />
        <path
          data-name="Path 11602"
          d="M100.22 325.14l8.09.88-2.93 10.1-7.88-1.59z"
          opacity={0.2}
        />
        <path
          data-name="Path 11603"
          d="M148.47 147.08S144 208.19 140 231.37c-4.41 25.39-30.07 103.12-30.07 103.12l-14.7-2.68s18.53-73 20.58-98.14c2.23-27.28 4.91-83.52 4.91-83.52z"
          fill="#18206b"
        />
        <path
          data-name="Path 11604"
          d="M140.94 172.45c.8-3.36 2.64.87 4.78 8.2-1.62 18.14-3.72 39.15-5.72 50.72-.45 2.6-1.13 5.74-2 9.3.74-25.89.77-59.14 2.94-68.22z"
          opacity={0.3}
        />
        <path
          data-name="Path 11605"
          d="M163.74 145.38s5.87 61.47 6.07 86.16c.21 25.69-5.08 109.79-5.08 109.79H151s-4.12-82.6-5.83-107.83c-1.87-27.5-9.74-85-9.74-85z"
          fill="#18206b"
        />
        <path
          data-name="Path 11606"
          d="M113 329.55c.06 0-2.31 5.32-2.31 5.32l-16.54-3 1-4.95z"
          fill="#263238"
        />
        <path
          data-name="Path 11607"
          d="M167.13 335.86c.06 0-.53 5.7-.53 5.7h-16.68l-.68-5.09z"
          fill="#263238"
        />
        <path
          data-name="Path 11608"
          d="M121.12 90.61c-1.1 2.13-2.31 4.37-3.41 6.58l-3.36 6.66c-1.09 2.22-2.16 4.45-3.19 6.67s-2 4.46-2.83 6.68l-.08-3.5a44 44 0 002.1 5.26c.39.88.89 1.72 1.32 2.59s1 1.7 1.51 2.52a57.844 57.844 0 003.44 4.91c.62.79 1.24 1.59 1.9 2.36s1.38 1.55 2 2.2l.2.22a2.88 2.88 0 01-.21 4.07 2.92 2.92 0 01-3.33.38 32.945 32.945 0 01-3-1.91c-1-.67-1.88-1.35-2.78-2.08a47.89 47.89 0 01-5.06-4.82 44.411 44.411 0 01-4.35-5.61 43 43 0 01-3.46-6.38 4.31 4.31 0 01-.21-3l.14-.47q1.14-3.91 2.55-7.63t3-7.29c1-2.4 2.17-4.75 3.34-7.08s2.35-4.62 3.7-6.94a5.8 5.8 0 1110.18 5.56z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11609"
          d="M126.86 87.07c.4 7.62-8.26 21.64-8.26 21.64l-17.83-8.91a52.49 52.49 0 019.88-17.23c9.43-10.44 15.84-2.57 16.21 4.5z"
          fill="#cf1e22"
        />
        <path
          data-name="Path 11610"
          d="M114.78 136.78l3.59 6 7.47-4.78a12.1 12.1 0 00-5.81-5.22 2.5 2.5 0 00-3 1.27z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11611"
          d="M121.36 145.34l3.47-.65a2.26 2.26 0 001.8-2.65l-.79-4-7.47 4.78.5 1.21a2.26 2.26 0 002.49 1.31z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11612"
          d="M142.43 48.71c.07.65.48 1.16.9 1.12s.7-.59.62-1.24-.48-1.16-.9-1.13-.7.59-.62 1.25z"
          fill="#263238"
        />
        <path
          data-name="Path 11613"
          d="M142.85 49.87a24.931 24.931 0 003.75 5.35c-1 1.18-3 .84-3 .84z"
          fill="#ff5652"
        />
        <path
          data-name="Path 11614"
          d="M139.63 45.26a.39.39 0 00.29-.09 2.9 2.9 0 012.63-.71.37.37 0 00.46-.27.4.4 0 00-.27-.47 3.66 3.66 0 00-3.34.86.4.4 0 00.23.68z"
          fill="#263238"
        />
        <path
          data-name="Path 11615"
          d="M122.27 56c1.91 5.78 4.45 16.46.83 20.73 0 0 2.38 5.83 13.34 4.91 12.07-1 5-6.45 5-6.45-6.78-1-7.24-5.89-6.68-10.56z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11616"
          d="M120.51 78.8c-1.13-1.81-2.39-3.88-.25-4.65 2.35-.85 15.55-2.23 20.25-1.08s3.74 5 3.74 5z"
          fill="#ffb921"
        />
        <path
          data-name="Path 11617"
          d="M159.16 81.24c1.72 1.58 3.58 3.32 5.43 4.93s3.72 3.24 5.6 4.82 3.8 3.07 5.73 4.52 3.89 2.76 5.85 3.95l-4-.37a14.93 14.93 0 004.65-2.15 31.08 31.08 0 004.58-3.88 54.3 54.3 0 004.21-4.88c.67-.86 1.34-1.74 2-2.65s1.26-1.87 1.81-2.71l.11-.16a2.89 2.89 0 015.19 2.39c-.38 1.3-.78 2.41-1.24 3.58s-.94 2.3-1.48 3.42a47.351 47.351 0 01-3.83 6.55 34.3 34.3 0 01-5.3 6 23.38 23.38 0 01-7.55 4.52 4.78 4.78 0 01-3.68-.21l-.33-.17a70.221 70.221 0 01-7.22-4.09c-2.27-1.47-4.47-3-6.59-4.63s-4.17-3.3-6.17-5-3.93-3.54-5.93-5.53a5.8 5.8 0 018.05-8.34z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11618"
          d="M153.05 76.05s10.08 9.79 11.25 70.28c-16.12 3.9-31.63 5.35-43.61 3.82-.57-7.58-1.42-33.92-9.12-61.7a8.76 8.76 0 016.79-11c1.53-.3 3.14-.57 4.74-.79a161.6 161.6 0 0118.34-1.54 80.428 80.428 0 0111.61.93z"
          fill="#cf1e22"
        />
        <path
          data-name="Path 11619"
          d="M145.23 86.59c1 7.57 14 22.12 14 22.12l15.43-16a127.2 127.2 0 00-14.82-13.3c-11.31-8.41-15.51.16-14.61 7.18z"
          fill="#cf1e22"
        />
        <path
          data-name="Path 11620"
          d="M199.32 87.71l5.16-4.71-6.18-6.35a12.1 12.1 0 00-4 6.74 2.51 2.51 0 001.86 2.72z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11621"
          d="M206.38 79.53l-1.33-3.27a2.27 2.27 0 00-3-1.22l-3.79 1.59 6.22 6.37 1.08-.74a2.24 2.24 0 00.82-2.73z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11622"
          d="M120.73 49c1.45 8 1.89 12.74 6.39 16.55 6.77 5.73 16.11 1.27 17-6.91.84-7.35-1.67-19.2-9.81-21.79S119.28 41 120.73 49z"
          fill="#ff8b7b"
        />
        <path
          data-name="Path 11623"
          d="M136.5 51.92c2.81.65 5-2.6 5.3-3.52-1.37.13-3.8-.58-4.28-1.19 1.5.13 2.95-1.72 3.13-2.43a6.21 6.21 0 01-3.93-2.56c2.43 0 5.35-4.32 2.68-8.15s-13.83-.62-15.42-3.36c-2.34 1.37-.26 3.18-.26 3.18s-15.79 3-8.51 9.08c-5.34.49-6.09 6.8-1.64 10s4.68 5.33 2.91 5.06c.71 1.37 3.88 1.55 4.06.22.75 2.78 2.91 6.53 7.89 5.91s9.88-7.56 8.07-12.24z"
          fill="#263238"
        />
        <path
          data-name="Path 11624"
          d="M116.61 42.05c-3.76.52-5.47-1.6-4.53-3.47-4.66 2.42.43 7.64 4.53 3.47z"
          fill="#263238"
        />
        <path
          data-name="Path 11625"
          d="M132.61 50.71a8.77 8.77 0 003.28 4.11c2 1.32 3.81 0 3.47-2-.31-1.84-1.72-4.75-3.8-5.27a2.38 2.38 0 00-2.95 3.16z"
          fill="#ff8b7b"
        />
      </g>
      <g>
        <path
          data-name="Path 11626"
          d="M386.78 332.56c-7.4-17.46-10.39-38-1.92-37.14 8.69.84 7.67 31.8 9.08 35.2-2.71 2.38-7.16 1.94-7.16 1.94z"
          fill="#a0d468"
        />
        <path
          data-name="Path 11627"
          d="M389.18 299.44c-1.82 6.65-3.75 16.95-5.22 25.67.84 2.5 1.79 5 2.82 7.46 0 0 4.44.38 7.17-1.95-1.12-2.68-.72-22.52-4.77-31.18z"
          fill="#263238"
        />
        <path
          data-name="Path 11628"
          d="M389.22 329.37c-2.32-37.11 4-71.49 20.64-69.94 14.28 1.34-6.54 63.8-6.14 71-6.54 2.57-14.5-1.06-14.5-1.06z"
          fill="#b8d98a"
        />
        <path
          data-name="Path 11629"
          d="M400 329.12c2.61-26.66 16.68-57.78 22.72-47.38 7.67 13.19-12 44.64-12.53 49.81-4.92 1.05-10.19-2.43-10.19-2.43z"
          fill="#4d7c1b"
        />
        <path
          data-name="Path 11630"
          d="M397.37 269.33c-1.69-.27-2.63-1.33-2.52-2.81.12-1.68 1.5-3.35 2.78-3.37.62 0 1.66.31 1.92 2.63l-1 .11c-.12-1.09-.45-1.74-.89-1.74-.68 0-1.72 1.24-1.8 2.44-.07 1 .49 1.56 1.68 1.76z"
          fill="#407bff"
        />
        <path
          data-name="Path 11631"
          d="M415.33 276.06a3.88 3.88 0 01-2-.77l.54-.83c.93.6 1.65.76 1.93.41.42-.53.13-2.11-.74-2.94-.7-.68-1.52-.62-2.43.17l-.65-.75a2.62 2.62 0 013.77-.15c1.22 1.16 1.63 3.29.83 4.3a1.48 1.48 0 01-1.25.56z"
          fill="#407bff"
        />
        <path
          data-name="Path 11632"
          d="M390.82 291.15a2.49 2.49 0 01-2.62-2c-.4-1.63.4-3.65 1.62-4.06.57-.2 1.67-.21 2.63 1.92l-.92.41c-.45-1-1-1.53-1.39-1.39-.64.22-1.25 1.72-1 2.88.23.95 1 1.34 2.14 1.16l.15 1a4.845 4.845 0 01-.61.08z"
          fill="#407bff"
        />
        <path
          data-name="Path 11633"
          d="M380.17 311.86a2.42 2.42 0 01-2.29-1.5c-.7-1.52-.29-3.65.82-4.29.53-.3 1.61-.52 2.95 1.39l-.82.58c-.64-.91-1.25-1.32-1.63-1.1-.59.34-.91 1.92-.41 3 .41.89 1.19 1.13 2.32.73l.33.95a4 4 0 01-1.27.24z"
          fill="#407bff"
        />
        <path
          data-name="Path 11634"
          d="M397.89 281.67a.52.52 0 01-.29-.09 3 3 0 01-1.32-3.64 3.38 3.38 0 013.49-2c.62.12 2.07.67 2.17 3.33a.5.5 0 01-1 0c-.06-1.39-.53-2.23-1.35-2.38a2.4 2.4 0 00-2.39 1.43c-.36.85 0 1.71 1 2.42a.5.5 0 01-.29.91z"
          fill="#fff"
        />
        <path
          data-name="Path 11635"
          d="M409.74 308.66a.48.48 0 01-.48-.4.49.49 0 01.38-.59c1.36-.28 2.11-.9 2.13-1.72a2.44 2.44 0 00-1.81-2.13c-.9-.21-1.7.28-2.23 1.38a.5.5 0 11-.9-.44 2.94 2.94 0 013.36-1.91 3.39 3.39 0 012.58 3.11c0 .63-.32 2.15-2.92 2.69z"
          fill="#fff"
        />
        <path
          data-name="Path 11636"
          d="M423.8 300.23c-.58 0-1.35-.34-2.21-1.63l.83-.56c.62.92 1.21 1.34 1.6 1.13.6-.33 1-1.9.47-3-.38-.9-1.16-1.16-2.3-.78l-.31-.95a2.635 2.635 0 013.53 1.33c.67 1.55.22 3.66-.91 4.28a1.39 1.39 0 01-.7.18z"
          fill="#407bff"
        />
        <path
          data-name="Path 11637"
          d="M420.82 338.92a22.22 22.22 0 00-5.39-14.54 1.47 1.47 0 001.24-1.42 1.49 1.49 0 00-1.48-1.48h-33.48a1.48 1.48 0 00-1.47 1.48 1.45 1.45 0 001.25 1.42A22.33 22.33 0 00388 358.7a1.62 1.62 0 00.75 3.06h19.39a1.62 1.62 0 00.75-3.06 22.36 22.36 0 0011.93-19.78z"
          fill="#472a04"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
